<script>
import TwButton from '@/components/generic/tw-button.vue'
import btnPropsMixin from '@/mixins/btnPropsMixin.js'
import { useOrganizationStore } from '@/stores/organization.js'
import { useAuthStore } from '@/stores/auth.js'
import { useUsersStore } from '@/stores/users.js'
import TwBadge from '@/components/generic/tw-badge.vue'

export default {
  name: 'UserAutoLoginButton',
  components: { TwBadge, TwButton },
  mixins: [btnPropsMixin],
  props: {
    user: {
      type: Object,
      required: true
    },
    redirectUrl: {
      type: String,
      default: null
    }
  },
  methods: {
    async autologinAsUser() {
      if(confirm(`Login as ${this.user.name}?`)) {
        await useAuthStore().startImpersonation(this.user.id)
        if(this.redirectUrl) {
          window.location.href = this.redirectUrl
        } else {
          await this.$router.push({ name: 'DashboardPage' })
        }
      }
    }
  }
}
</script>

<template>
  <tw-button variant="primary" :size="size" @click="autologinAsUser">
    Auto Login as <tw-badge :size="size">
      {{ user.name }}
    </tw-badge>
  </tw-button>
</template>

<style scoped>

</style>
